import { useTranslation } from 'react-i18next';
import { qaStages } from '@/mocks/howItWorks';

export default function QualityAssurance() {
  const { t } = useTranslation('howItWorks');

  return (
    <section className="w-full bg-cream-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="text-xs font-semibold text-warm-500 uppercase tracking-[0.2em] mb-3 block">
              {t('qa.label')}
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-ink-700 mb-4">
              {t('qa.title')}
            </h2>
            <p className="text-sm md:text-base text-ink-400 max-w-2xl mx-auto leading-relaxed">
              {t('qa.subtitle')}
            </p>
            <div className="w-16 h-1 bg-warm-500 mx-auto mt-6 rounded-full" />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {qaStages.map((stage, index) => (
              <div
                key={stage.titleKey}
                className="relative p-6 bg-white border border-ink-100 rounded-xl"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-11 h-11 rounded-xl bg-warm-50 flex items-center justify-center">
                    <i className={`${stage.icon} text-warm-500 text-xl`} />
                  </div>
                  <span className="text-xs font-bold text-warm-500 tracking-wide">
                    0{index + 1}
                  </span>
                </div>
                <h3 className="text-base md:text-lg font-semibold text-ink-700 mb-2">
                  {t(stage.titleKey)}
                </h3>
                <p className="text-xs md:text-sm text-ink-400 leading-relaxed">
                  {t(stage.descKey)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}